import styled from 'styled-components';
import { BodyText } from '@make-software/cspr-design';

interface HiddenTextProps {
  text: string;
  hide: boolean;
  dotsNumber: number;
  color?: 'gray' | 'black' | 'green' | 'red';
  scale?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  size?: 1 | 2 | 3 | 4;
}

const StyledDots = styled(BodyText)(({ theme }) =>
  theme.withMedia({
    wordBreak: ['unset', 'unset', 'break-word']
  })
);

export const HiddenText = ({ text, hide, dotsNumber, color, scale, size }: HiddenTextProps) => {
  if (!hide)
    return (
      <BodyText
        size={size || 1}
        monotype
        variation={color}
        scale={scale}
        style={{
          whiteSpace: 'normal', // allow wrapping
          wordBreak: 'break-word', // break long words if needed
          overflowWrap: 'anywhere' // modern way to ensure wrapping
        }}
      >
        {text}
      </BodyText>
    );

  const dots = dotsNumber ? dotsNumber : text.length;
  let newArray = Array.from({ length: dots }, (value, index) => index.toString());

  const hashStart = text.slice(0, 4);
  const hashEnd = text.slice(text.length - 4);
  return (
    <StyledDots size={size || 1} scale={scale ? scale : 'sm'} variation={color} monotype>
      {hashStart}
      {newArray.fill('.').join('')}
      {hashEnd}
    </StyledDots>
  );
};
